import { ContainerRenderingProps } from 'components/renderings/structureRenderings/ContainerRendering';
import styled, { css } from 'styled-components';

export const Container = styled.div<Pick<ContainerRenderingProps, 'rendering'>>`
	margin-left: auto;
	margin-right: auto;
	padding: 0 16px;

	${({ rendering }) =>
		rendering.params.Variant === 'Small' &&
		css`
			@media (min-width: 568px) {
				width: 508px;
			}
			@media (min-width: 768px) {
				width: 568px;
			}
			@media (min-width: 992px) {
				width: 612px;
			}
			@media (min-width: 1200px) {
				width: 732px;
			}
			@media (min-width: 1800px) {
				width: 824px;
			}
		`}

	${({ rendering }) =>
		rendering.params.Variant === 'Medium' &&
		css`
			width: 1170px;
			max-width: 100%;
		`}
	
	${({ rendering }) =>
		rendering.params.Variant === 'Full' &&
		css`
			margin-left: unset;
			margin-right: unset;
			padding: unset;
			background: url(https://edge.sitecorecloud.io/osi-60501bcc/media/Project/BBI/outback/static-pages/texture-slate.png)
				0 0 repeat #262524;
		`}
`;
